import m from "mithril";

export const fetchGlobalSettings = (): Promise<{ data: Record<string, string> }> => {
  return m.request({
    method: "GET",
    url: "/auth/config",
  });
};
